// Native-style "Add a passkey" reference look: a plain bordered button with
// no tenant brand color, used consistently across every passkey action
// button (Security & Login page, its modals, the mandatory hard-block page,
// and the login-time nudge/banners) regardless of primary/secondary/danger
// intent.
const passkeyButtonClassName = 'rounded-lg border border-[var(--owner-border-strong)] bg-[var(--owner-surface)] font-normal text-[var(--owner-text)] shadow-none hover:bg-[var(--owner-surface-muted)]';

// OWN-222 styling pass: the one deliberate exception to the neutral rule above -
// destructive actions (Remove) get a red outline so they read as dangerous at a
// glance, per the updated Security & Login mock.
export const passkeyDangerButtonClassName = 'rounded-lg border border-red-300 bg-[var(--owner-surface)] font-normal text-red-600 shadow-none hover:bg-red-50';

// OWN-223: the other deliberate exception - the main forward action in each
// passkey modal/prompt (Continue, Register Passkey, "I've saved these codes")
// uses the tenant's own brand color so it reads as the obvious next step,
// rather than looking identical to Cancel/Skip. --tenant-primary is set on
// :root per tenant in App.js.
export const passkeyPrimaryButtonClassName = 'rounded-lg border border-transparent bg-[var(--tenant-primary)] font-normal text-white shadow-sm transition-[filter] hover:brightness-110 active:brightness-95';

export default passkeyButtonClassName;
